import React from 'react';

interface InputWithAddonProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  suffix?: string;
  prefix?: string;
  type?: 'text' | 'number';
  placeholder?: string;
  min?: string | number;
  max?: string | number;
  step?: string | number;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

export const InputWithAddon: React.FC<InputWithAddonProps> = ({
  label,
  value,
  onChange,
  suffix,
  prefix,
  type = 'text',
  placeholder,
  min,
  max,
  step,
  required = false,
  disabled = false,
  className = '',
}) => {
  const hasValue = value !== '';

  return (
    <div className={`tw-relative ${className}`}>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || label}
        min={min}
        max={max}
        step={step}
        required={required}
        disabled={disabled}
        className={`
          tw-w-full tw-text-base tw-border tw-border-gray-200 tw-rounded-xl
          tw-peer tw-placeholder-transparent tw-transition-all tw-duration-200
          focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-affinicar-primary/20 focus:tw-border-affinicar-primary
          disabled:tw-opacity-50 disabled:tw-cursor-not-allowed
          ${prefix ? 'tw-pl-10' : 'tw-pl-3'}
          ${suffix ? 'tw-pr-14' : 'tw-pr-3'}
          tw-pt-5 tw-pb-1.5
        `}
      />
      {/* Floating label */}
      <label className={`
        tw-absolute tw-pointer-events-none tw-transition-all tw-duration-200 tw-origin-left
        ${prefix ? 'tw-left-10' : 'tw-left-3'}
        ${hasValue
          ? 'tw-top-1.5 tw-text-[11px] tw-text-affinicar-primary'
          : 'tw-top-[13px] tw-text-base tw-text-gray-400 peer-focus:tw-top-1.5 peer-focus:tw-text-[11px] peer-focus:tw-text-affinicar-primary'
        }
      `}>
        {label}
        {required && <span className="tw-text-red-400 tw-ml-0.5">*</span>}
      </label>
      {/* Prefix */}
      {prefix && (
        <span className="tw-absolute tw-left-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-gray-400 tw-text-sm tw-pointer-events-none">
          {prefix}
        </span>
      )}
      {/* Suffix */}
      {suffix && (
        <span className="tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-gray-400 tw-text-sm tw-pointer-events-none tw-bg-white tw-px-1">
          {suffix}
        </span>
      )}
    </div>
  );
};
